import { gql } from "@apollo/client";

export const REFUND_ORDER = gql`
mutation refundOrder($id: ID!) { 
  refundOrder(id: $id)
}
`